export default {
  capacityOptionIndividual: {
    id: 'report_illicit_content_capacity_option_individual',
    defaultMessage: 'Individual',
  },

  capacityOptionCompany: {
    id: 'report_illicit_content_capacity_option_company',
    defaultMessage: 'Company',
  },

  capacityOptionAuthority: {
    id: 'report_illicit_content_capacity_option_authority',
    defaultMessage: 'Authority',
  },

  capacityOptionTrustedFlagger: {
    id: 'report_illicit_content_capacity_option_trusted_flagger',
    defaultMessage: 'Trusted flagger',
  },

  capacityOptionRightsHolder: {
    id: 'report_illicit_content_capacity_option_rights_holder',
    defaultMessage: 'Rights holder',
  },

  capacityOptionOther: {
    id: 'report_illicit_content_capacity_option_other',
    defaultMessage: 'Other',
  },

  riskNatureOptionFire: {
    id: 'report_illicit_content_risk_nature_option_fire',
    defaultMessage: 'Fire',
  },

  riskNatureOptionElectricShock: {
    id: 'report_illicit_content_risk_nature_option_electric_shock',
    defaultMessage: 'Electric shock',
  },

  riskNatureOptionSuffocation: {
    id: 'report_illicit_content_risk_nature_option_suffocation',
    defaultMessage: 'Suffocation',
  },

  riskNatureOptionChemical: {
    id: 'report_illicit_content_risk_nature_option_chemical',
    defaultMessage: 'Chemical',
  },

  riskNatureOptionInjury: {
    id: 'report_illicit_content_risk_nature_option_injury',
    defaultMessage: 'Injury',
  },

  riskNatureOptionOther: {
    id: 'report_illicit_content_risk_nature_option_other',
    defaultMessage: 'Other',
  },

  yesNoUnknownOptionYes: {
    id: 'report_illicit_content_yes_no_unknown_option_yes',
    defaultMessage: 'Yes',
  },

  yesNoUnknownOptionNo: {
    id: 'report_illicit_content_yes_no_unknown_option_no',
    defaultMessage: 'No',
  },

  yesNoUnknownOptionUnknown: {
    id: 'report_illicit_content_yes_no_unknown_option_unknown',
    defaultMessage: 'I don’t know',
  },

  categoryErrorRequired: {
    id: 'report_illicit_content_category_error_required',
    defaultMessage: 'Please select a category.',
  },

  descriptionErrorRequired: {
    id: 'report_illicit_content_description_error_required',
    defaultMessage: 'Please describe the illicit content.',
  },

  descriptionErrorMaxLength: {
    id: 'report_illicit_content_description_error_max_length',
    defaultMessage: 'The description must be at most {maxLength} characters.',
  },

  contentUrlErrorRequired: {
    id: 'report_illicit_content_content_url_error_required',
    defaultMessage: 'Please provide the URL of the illicit content.',
  },

  contentUrlErrorInvalid: {
    id: 'report_illicit_content_content_url_error_invalid',
    defaultMessage:
      'Please enter a valid URL starting with http:// or https://.',
  },

  reporterNameErrorRequired: {
    id: 'report_illicit_content_reporter_name_error_required',
    defaultMessage: 'Please enter your name or organization.',
  },

  reporterEmailErrorRequired: {
    id: 'report_illicit_content_reporter_email_error_required',
    defaultMessage: 'Please enter your email address.',
  },

  reporterEmailErrorInvalid: {
    id: 'report_illicit_content_reporter_email_error_invalid',
    defaultMessage: 'Please enter a valid email address.',
  },

  capacityErrorRequired: {
    id: 'report_illicit_content_capacity_error_required',
    defaultMessage: 'Please select a capacity.',
  },

  countryErrorRequired: {
    id: 'report_illicit_content_country_error_required',
    defaultMessage: 'Please enter your country of residence.',
  },

  riskNatureErrorRequired: {
    id: 'report_illicit_content_risk_nature_error_required',
    defaultMessage: 'Please select the nature of the risk.',
  },

  hasCausedIncidentErrorRequired: {
    id: 'report_illicit_content_has_caused_incident_error_required',
    defaultMessage: 'Please select an answer.',
  },

  isSubjectToRecallErrorRequired: {
    id: 'report_illicit_content_is_subject_to_recall_error_required',
    defaultMessage: 'Please select an answer.',
  },

  goodFaithCertifiedErrorMustBeChecked: {
    id: 'report_illicit_content_good_faith_certified_error_must_be_checked',
    defaultMessage: 'You must certify this report to submit it.',
  },
}
